import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "../../../actions/actionCreators";
import withModal from "../withModal";
import MaterialModal from "../MaterialModal";
import FlowItemQADisplay from "../../flows/item/Shared/FlowItemQADisplay";

const PreviewFlowItemResultsModal = ({ modalProps, isOpen }) => {
    const dispatch = useDispatch();
    const { flowItemId, isQA } = modalProps;
    const flowItem = useSelector(state => (flowItemId ? state.flowItems.byId[flowItemId] : null));

    const hide = () => dispatch(hideModal("PREVIEW_FLOW_ITEM_RESULTS"));

    const renderInner = () => {
        if (!flowItem) {
            return (
                <p className="text-center" style={{ margin: "25px auto" }}>
                    Unknown flow item.
                </p>
            );
        }

        if ((!isQA && !flowItem.HasResultTable) || (isQA && !flowItem.HasQATable)) {
            return (
                <p className="text-center" style={{ margin: "25px auto" }}>
                    Results are not computed.
                </p>
            );
        }

        return <FlowItemQADisplay flowItemId={flowItemId} />;
    };

    const getTitle = () => {
        const thing = isQA ? "QA" : "Preview";
        const noun = flowItem ? flowItem.FlowItemName : "Flow Item";
        return `${noun} ${thing}`;
    };

    const downloadReport = () => {
        hide();
        window.location = "/FlowItemReports/QAExport/" + flowItemId;
    };

    return isOpen ? (
        <MaterialModal
            title={getTitle()}
            isOpen={isOpen}
            onClose={hide}
            id="flow-item-results-preview"
            maxWidth="lg"
            innerDescription={`${
                flowItem && flowItem.FlowItemType == "export"
                    ? "The records shown are a random sample. Also, if the layout used contains fields from the Layouts folder, those fields are skipped in this preview."
                    : ""
            }`}
            primaryButtonText="Download Report"
            onPrimaryButtonRequest={downloadReport}
        >
            {renderInner()}
        </MaterialModal>
    ) : null;
};

PreviewFlowItemResultsModal.propTypes = {
    // Redux
    flowItem: PropTypes?.any,
    // WithModal
    modalProps: PropTypes.object,
    isOpen: PropTypes.bool,
    // Redux AC
    hideModal: PropTypes.func,
};

export default withModal(PreviewFlowItemResultsModal, "PREVIEW_FLOW_ITEM_RESULTS");
